import { DynamicFieldData } from '@/shared/components/DynamicForm/models/DynamicFieldData'
import { DynamicFormDefinition } from '@/shared/components/DynamicForm/models/DynamicFormSection'
import { FormFieldDefaultValue, FormFieldSelectOptions, getDynamicFormFields } from '@/shared/lib/getDynamicFormFields'

const defaultCompartmentDetailFields: DynamicFieldData[] = [
  {
    fieldType: 'select',
    fieldName: 'groupId',
    label: 'Group',
    placeholder: 'Select Group',
    required: true,
    options: [],
    config: {
      required: 'Group is required',
    },
  },
  {
    fieldType: 'text',
    fieldName: 'name',
    label: 'Name',
    placeholder: 'Enter Compartment Name',
    defaultValue: '',
    required: true,
    config: {
      required: 'Name is required',
    },
  },
  {
    fieldType: 'number',
    fieldName: 'weightCapacity',
    label: 'Weight Capacity',
    placeholder: 'Enter Weight Capacity',
    defaultValue: 0,
    config: {
      min: {
        value: 0,
        message: 'Weight capacity must be greater than or equal to 0',
      },
    },
  },
  {
    fieldType: 'number',
    fieldName: 'volumeCapacity',
    label: 'Volume Capacity',
    placeholder: 'Enter Volume Capacity',
    defaultValue: 0,
    config: {
      min: {
        value: 0,
        message: 'Volume capacity must be greater than or equal to 0',
      },
    },
  },
  {
    fieldType: 'multiselect',
    fieldName: 'attributeIds',
    label: 'Attributes',
    placeholder: 'Select Compartment Attributes',
    defaultValue: [],
    options: [],
  },
  {
    fieldType: 'checkbox',
    fieldName: 'isActive',
    label: 'Is Compartment Active',
    defaultValue: true,
    labelPlacement: 'end',
  },
]

export const initialCompartmentFormValues = {
  name: '',
  groupId: undefined,
  weightCapacity: 0,
  volumeCapacity: 0,
  attributeIds: [],
  isActive: true,
}

type GetCompartmentFormDefinitionArgs = {
  defaultValues?: FormFieldDefaultValue
  selectOptions?: FormFieldSelectOptions
}

export const getCompartmentFormDefinition = ({
  defaultValues,
  selectOptions,
}: GetCompartmentFormDefinitionArgs): DynamicFormDefinition => {
  const fields = getDynamicFormFields({
    fields: defaultCompartmentDetailFields,
    defaultValues,
    selectOptions,
  })

  const formDefinition: DynamicFormDefinition = {
    formType: 'default',
    sections: [
      {
        label: 'Compartment Details',
        fields,
      },
    ],
  }

  return formDefinition
}